export enum EMediaCenterEvents {
    RENDER_FILTERED_SLIDES = 'mediaCenter:render:filtered',
}
